import { createGlobalStyle } from 'styled-components';
import  Logo  from '../../assets/img/logoEleccion.png';

const PrintStyles = createGlobalStyle`
/***********************TEMPLATE - INICIO********************************/
.pdfPrint {
  width: 753px;
  font-family: 'Lato', Arial;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.pdfPrint table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
}

.pdfPrint table img {
  margin-right: 10px;
}

.pdfPrint .datosGeneralesTotal {
  width: 100%;
  /* float: left; */
}

.pdfPrint .datosGeneralesTotal .smallContainer {
  width: 50%;
  float: left;
}

.pdfPrint .datosGeneralesTotal .smallContainer table tbody tr td:first-child {
  width: 50%;
}
.pdfPrint .datosGeneralesTotal .smallContainer table tbody tr td:nth-child(2),
.pdfPrint .datosGeneralesTotal .smallContainer table tbody tr td:nth-child(3) {
  width: 25%;
}

.pdfPrint article {
  margin: 20px 0 0 0;
  float: left;
  width: 100%;
}
.pdfPrint section {
  /* margin: 30px 0 0 0; */
  float: left;
}
.pdfPrint .headerSection {
  font-weight: 900;
  /* color: #355f39; */
  font-size: 18px;
  text-transform: uppercase;
  margin: 20px 0;
}
.pdfPrint .subHeader {
  font-weight: 700;
  /* color: #355f39; */
  font-size: 14px;
  text-transform: uppercase;
  margin: 20px 0;
}
.pdfPrint .percent {
  font-weight: 700;
  font-size: 18px;
}
.pdfPrint .cargos {
  font-weight: 600;
  font-size: 24px;
}
.pdfPrint .importantData {
  font-weight: 500;
}

/***********************TEMPLATE - FIN********************************/

/***********************HEADER - INICIO********************************/

.pdfPrint .header {
  color: #ffffff;
  height: 134px;
  /* width: 753px; */
  /* border-bottom: 11px solid; */
  background-image: url(${Logo});
  background-position: top right;
  background-repeat: no-repeat;
  background-color: #1c283d;
  background-size: 173px 130px;
}

.pdfPrint .header .nombreElec {
  font-size: 24px;
  font-weight: bold;
  height: 43px;
  text-align: center;
  padding-top: 30px;
}
.pdfPrint .header .ambitoyDatos {
  text-align: left;
  font-size: 24px;
  font-weight: normal;
  height: 61px;
  text-indent: 5px;
  text-transform: uppercase;
}
.pdfPrint .header .datosdeLas {
  font-size: 14px;
  font-weight: normal;
  text-indent: 5px;
  text-transform: capitalize;
}

/***********************HEADER - FIN********************************/

/***********************DATOS GENERALES TOTAL - INICIO************************************************************/
.pdfPrint .datosGeneralesTotal table {
  border-top: 1px solid #dadada;
}
.pdfPrint .datosGeneralesTotal table thead {
  display: none;
}
.pdfPrint .datosGeneralesTotal table tbody tr td {
  width: 25%;
  line-height: 40px;
}

.pdfPrint .datosGeneralesTotal table tr td:first-child {
  width: 50%;
}
.pdfPrint .datosGeneralesTotal table tbody tr {
  border-bottom: 1px solid #dadada;
}
.pdfPrint .camaracircunscripcion{
	width:100%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tr .votes,
.pdfPrint .camaracircunscripcion .datosGenerales table tr .percent {
  text-align:right;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tr .margin {
  padding-right: 5%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tr td:nth-child(2),
.pdfPrint .camaracircunscripcion .datosGenerales table tr td:nth-child(5) {
  padding-right: 5%;
}

/***********************DATOS GENERALES TOTAL - FIN*****************************************************************/

/***********************CÁMARA CIRCUNSCRIPCIÓN - INICIO*************************************************************/

/***********************DATOS GENERALES - INICIO********************************/
.pdfPrint .camaracircunscripcion .datosGenerales table {
  border-bottom: 1px solid #dadada;
  /* border-top: 1px solid #dadada; */
}

.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr:first-child,
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr:nth-child(2),
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr:nth-child(4) {
  border-top: 1px solid #dadada;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td {
  line-height: 50px;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:first-child {
  width: 25%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(2),
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(3) {
  width: 15%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(4) {
  width: 25%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(5),
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(6) {
  width: 15%;
}
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(4),
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(5),
.pdfPrint .camaracircunscripcion .datosGenerales table tbody tr td:nth-child(6) {
  border-bottom: 1px solid #dadada;
}
/***********************DATOS GENERALES - FIN**********************************/

/***********************VOTOS a PARTIDOS - INICIO********************************/
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr:first-child {
  border-top: 1px solid #dadada;
}

.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr.partido td {
  /* line-height: 50px; */
}
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr.partido td img {
  vertical-align: middle;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr.candidato td:first-child {
  text-indent: 10px;
  line-height: 30px;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr:nth-child(2n + 2) {
  background-color: #f1f3f5;
}

.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr th:first-child,
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr td:first-child {
  width: 65%;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr th:nth-child(2),
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr td:nth-child(2) {
  width: 15%;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr th:nth-child(3),
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr td:nth-child(3) {
  width: 10%;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr th:nth-child(4),
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr td:nth-child(4) {
  width: 10%;
  text-align: right;
}

.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr .votesCenter {
  text-align:center;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr .votes,
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr .percent {
  text-align:right;
}
.pdfPrint .camaracircunscripcion .votosAPartidos table thead tr .margin,
.pdfPrint .camaracircunscripcion .votosAPartidos table tbody tr .margin {
  padding-right: 6%;
}

/***********************VOTOS a PARTIDOS - FIN********************************/

/***********************RESUMEN POR TERRITORIOS - INICIO********************************/
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr {
  border-top: 1px solid #dadada;
}
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td {
  /* line-height: 50px; */
}
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td img {
  vertical-align: middle;
}
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(1),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(1) {
  width: 20%;
}
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(2),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(2) {
  width: 36%;
}

.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(3),
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(4),
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(5),
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(6),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(3),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(4),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(5),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(6) {
  width: 11%;
}

.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(3) {
  text-align: right;
  padding-right: 10px;
}
.pdfPrint .camaracircunscripcion .resumenTerritorios table thead tr th:nth-child(4) {
  text-align: center;
}

.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(3),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(4),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(5),
.pdfPrint .camaracircunscripcion .resumenTerritorios table tbody tr td:nth-child(6) {
  text-align: right;
}

/***********************RESUMEN POR TERRITORIOS - FIN********************************/

/***********************CÁMARA CIRCUNSCRIPCIÓN - FIN*******************************************************************************+***************/

.pdfPrint .tablaEstadisticasPartidos tr:nth-child(2n) {
  background-color: #f1f3f5;
}

`;

export default PrintStyles;